/**
 * This is a wrapper for IA Analytics to make it easier to use in components
 */
export default class AnalyticsHandler {
  /**
   * Creates an instance of AnalyticsHandler.
   *
   * @param {*} analyticsBackend An analytics backend to use. Defaults to `window.archive_analytics`
   * @memberof AnalyticsHandler
   */
  constructor(analyticsBackend) {
    this.analyticsBackend = analyticsBackend || window.archive_analytics;
  }

  /**
   * Sends a tracking event.
   *
   * @param {string} category
   * @param {string} action
   * @param {string} label Defaults to `window.location.pathname`
   * @param {Object} additionalEventParams These are internal params, not sent to GA
   */
  send_event(
      category, action, label, additionalEventParams,
  ) {
    if (!this.analyticsBackend) return;
    this.analyticsBackend.send_event(
      category, action, label, additionalEventParams,
    );
  }

  /**
   * Sends every event instead of a small percentage.
   *
   * Use this sparingly as it can generate a lot of events.
   *
   * @param {string} category
   * @param {string} action
   * @param {string} label
   * @param {Object} additionalEventParams These are internal params, not sent to GA
   */
  send_event_no_sampling(
      category, action, label, additionalEventParams,
  ) {
    if (!this.analyticsBackend) return;
    this.analyticsBackend.send_event_no_sampling(
      category, action, label, additionalEventParams,
    );
  }
}
